import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-invoices',
    imports: [RouterOutlet],
    templateUrl: './invoices.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './invoices.component.scss'
})
export class InvoicesComponent {}
